"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvoices = exports.exportInvoices = exports.createRefund = exports.createCancel = exports.createAuthorize = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _moment = _interopRequireDefault(require("@package/moment"));

var _errors = require("@package/errors");

var _request = _interopRequireDefault(require("@package/request"));

var _dialog = require("@package/dialog");

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("./slice");

var INVOICE_PAYED = 3;
var INVOICE_PARTLY_REFUNDED = 6;
var INVOICE_REFUNDED = 7;
var INVOICE_CANCELED = 8;

var getInvoices = function getInvoices() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var params, result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                message: 'Получение списка счетов'
              });
              dispatch((0, _slice.getInvoicesRequestAction)());
              params = {};

              if (query['order'] === 'created') {
                params['creationDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['creationDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'updated') {
                params['lastUpdatedDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['lastUpdatedDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'both') {
                params['allDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['allDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              }

              if (query['status'] > -1) {
                params['status'] = query['status'];
              }

              if (query['searchTerm']) {
                params['searchTerm'] = query['searchTerm'];
              }

              if (query['amountFrom']) {
                params['minAmount'] = query['amountFrom'];
              }

              if (query['amountTo']) {
                params['maxAmount'] = query['amountTo'];
              }

              if (query['page'] && typeof query['page'] === 'number' && Number(query['page']) > 0) {
                params['skip'] = (query['page'] - 1) * query['take'];
              }

              if (query['take']) {
                params['take'] = query['take'];
              }

              if (!query['shopDemoMode']) {
                params['shopDemoMode'] = false;
              }

              _context.next = 14;
              return (0, _request["default"])({
                url: '/invoices',
                method: 'get',
                params: params
              });

            case 14:
              result = _context.sent;
              dispatch((0, _slice.getInvoicesRequestSuccessAction)(result));
              _context.next = 25;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", void 0);

            case 22:
              dispatch((0, _slice.getInvoicesRequestFailAction)(_context.t0));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при получении списка счетов'
              });

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getInvoices = getInvoices;

var createRefund = function createRefund(formData) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var count, invoice, notExit, _yield$request, items;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                message: 'Создание возврата'
              });
              dispatch((0, _slice.createRefundRequestAction)());
              _context2.next = 5;
              return (0, _request["default"])({
                url: '/invoices/refund',
                method: 'post',
                data: formData
              });

            case 5:
              count = 0;
              invoice = null;
              notExit = true;

            case 8:
              ++count;
              _context2.next = 11;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 11:
              _context2.next = 13;
              return (0, _request["default"])({
                url: "/invoices",
                method: 'get',
                params: {
                  externalId: formData['externalId']
                }
              });

            case 13:
              _yield$request = _context2.sent;
              items = _yield$request.data;

              if (items.length > 0) {
                if (items[0]['status']['code'] === INVOICE_REFUNDED || items[0]['status']['code'] === INVOICE_PARTLY_REFUNDED) {
                  if (items[0]['finalAmount'] < formData['finalAmount']) {
                    invoice = items[0];
                    notExit = false;
                  }
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context2.next = 18;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 18:
              if (notExit) {
                _context2.next = 8;
                break;
              }

            case 19:
              dispatch((0, _slice.createRefundRequestSuccessAction)(invoice));
              dispatch((0, _dialog.closeDialog)('create-refund'));
              dispatch(notifications.pushSuccess("\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043F\u043E \u0441\u0447\u0435\u0442\u0443 \u2116".concat(formData['externalId'], " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D \u0443\u0441\u043F\u0435\u0448\u043D\u043E")));
              _context2.next = 31;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 28;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 28:
              dispatch((0, _slice.createRefundRequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при создании возврата'
              });

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 24]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.createRefund = createRefund;

var createAuthorize = function createAuthorize(formData) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var count, invoice, notExit, _yield$request2, items;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на авторизацию счета'
              });
              dispatch((0, _slice.createAuthRequestAction)(formData['id']));
              _context3.next = 5;
              return (0, _request["default"])({
                url: "/invoices/authorize",
                method: 'post',
                data: {
                  id: formData['id'],
                  amount: formData['amount']
                }
              });

            case 5:
              count = 0;
              invoice = null;
              notExit = true;

            case 8:
              ++count;
              _context3.next = 11;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 11:
              _context3.next = 13;
              return (0, _request["default"])({
                url: "/invoices",
                method: 'get',
                params: {
                  externalId: formData['externalId']
                }
              });

            case 13:
              _yield$request2 = _context3.sent;
              items = _yield$request2.data;

              if (items.length > 0) {
                if (!!~[INVOICE_PAYED, INVOICE_REFUNDED, INVOICE_PARTLY_REFUNDED].indexOf(items[0]['status']['code'])) {
                  invoice = items[0];
                  notExit = false;
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context3.next = 18;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 18:
              if (notExit) {
                _context3.next = 8;
                break;
              }

            case 19:
              dispatch((0, _slice.createAuthRequestSuccessAction)(invoice));
              dispatch(notifications.pushSuccess('Операция выполнена успешно'));
              _context3.next = 30;
              break;

            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 27;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 27:
              dispatch((0, _slice.createAuthRequestFailAction)(formData['id']));
              dispatch(notifications.pushFail(_context3.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при запросе на авторизацию счета'
              });

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 23]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.createAuthorize = createAuthorize;

var createCancel = function createCancel(formData) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(dispatch) {
      var count, invoice, notExit, _yield$request3, items;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на отмену авторизации счета'
              });
              dispatch((0, _slice.createCancelRequestAction)(formData['id']));
              _context4.next = 5;
              return (0, _request["default"])({
                url: '/invoices/cancel',
                method: 'post',
                data: {
                  id: formData['id'],
                  reason: formData['reason']
                }
              });

            case 5:
              count = 0;
              invoice = null;
              notExit = true;

            case 8:
              ++count;
              _context4.next = 11;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 11:
              _context4.next = 13;
              return (0, _request["default"])({
                url: "/invoices",
                method: 'get',
                params: {
                  externalId: formData['externalId']
                }
              });

            case 13:
              _yield$request3 = _context4.sent;
              items = _yield$request3.data;

              if (items.length > 0) {
                if (!!~[INVOICE_CANCELED].indexOf(items[0]['status']['code'])) {
                  invoice = items[0];
                  notExit = false;
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context4.next = 18;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 18:
              if (notExit) {
                _context4.next = 8;
                break;
              }

            case 19:
              dispatch((0, _slice.createCancelRequestSuccessAction)(invoice));
              dispatch(notifications.pushSuccess('Операция выполнена успешно'));
              _context4.next = 30;
              break;

            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](0);

              if (!(_context4.t0 instanceof _errors.UnauthorizedError)) {
                _context4.next = 27;
                break;
              }

              return _context4.abrupt("return", void 0);

            case 27:
              dispatch((0, _slice.createCancelRequestFailAction)(formData['id']));
              dispatch(notifications.pushFail(_context4.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при запросе на отмену авторизации счета'
              });

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 23]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.createCancel = createCancel;

var exportInvoices = function exportInvoices() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(dispatch) {
      var formData, result, blob;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              (0, _logger.push)({
                message: 'Экспорт списка счетов'
              });
              dispatch((0, _slice.exportInvoicesRequestAction)());
              formData = {};

              if (query['order'] === 'created') {
                formData['creationDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['creationDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'updated') {
                formData['lastUpdatedDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['lastUpdatedDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'both') {
                formData['allDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['allDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              }

              if (query['status'] > -1) {
                formData['status'] = query['status'];
              }

              if (query['searchTerm']) {
                formData['searchTerm'] = query['searchTerm'];
              }

              if (query['amountFrom']) {
                formData['minAmount'] = query['amountFrom'];
              }

              if (query['amountTo']) {
                formData['maxAmount'] = query['amountTo'];
              }

              query['shopDemoMode'] ? delete formData['shopDemoMode'] : formData['shopDemoMode'] = false;
              _context5.next = 12;
              return (0, _request["default"])({
                url: '/invoices/export',
                method: 'get',
                responseType: 'text',
                params: formData
              });

            case 12:
              result = _context5.sent;
              blob = new Blob(["\uFEFF" + result], {
                type: 'text/csv;charset=utf-8;'
              });
              (0, _utils.saveAs)(blob, "invoices-".concat((0, _moment["default"])().format('DD-MM-YYYY'), ".csv"));
              dispatch((0, _slice.exportInvoicesRequestSuccessAction)());
              dispatch(notifications.pushSuccess('Файл скачан успешно'));
              _context5.next = 26;
              break;

            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](0);

              if (!(_context5.t0 instanceof _errors.UnauthorizedError)) {
                _context5.next = 23;
                break;
              }

              return _context5.abrupt("return", void 0);

            case 23:
              dispatch((0, _slice.exportInvoicesRequestFailAction)(_context5.t0['data']));
              dispatch(notifications.pushFail(_context5.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при экспорте счетов'
              });

            case 26:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 19]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.exportInvoices = exportInvoices;